import PropTypes from "prop-types";
import React from "react";
import "./style.scss";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import PreviewRow from "../../elements/preview-row";

export default function ComparisionToolLevelSummary({
  detailsLabel,
  details,
  currency,
  price,
  cta,
  allDetailsLink,
  isHidePrice
}) {
  return (
    <div className="level-summary-details">
      <span className="details-label">{detailsLabel}</span>
      <div className="details-container">
        {details &&
          details.map((detail, index) => {
            return (
              <PreviewRow
                key={detail.id}
                label={detail.fields.label?.value}
                value={detail.fields.value?.value}
                disclaimer={detail.fields.disclaimer?.value}
                icon={{ icon: detail.fields.icon?.value }}
              />
            );
          })}
      </div>
      <div className="price-and-info">
        {!isHidePrice && (currency || price) && (
          <span className="price-info">
            {currency} {price}
          </span>
        )}
        {allDetailsLink && (
          <SimpleLink
            {...{
              ...allDetailsLink
            }}
          />
        )}
      </div>
      <div className="primary-button-container">
        {cta && <PrimaryButton {...cta} />}
      </div>
    </div>
  );
}

ComparisionToolLevelSummary.propTypes = {
  detailsLabel: PropTypes.string,
  details: PropTypes.array,
  currency: PropTypes.string,
  price: PropTypes.string,
  cta: PropTypes.object,
  allDetailsLink: PropTypes.object
};
